import { useState, useEffect } from 'react'
import { Col } from 'react-bootstrap'

import { EDIT_TYPE } from '../../constants/editType'
import {
    createCourseBasePic,
    deleteCourseBasePic,
} from '../../store/actions/courseBaseActions'
import history from '../../history'
import PictureAddBase from '../PictureAddBase'

const FormCouseBasePictures = ({
    pictures,
    setPictures,
    editType,
    courseBaseId,
    dispatch,
}) => {
    const [name, setName] = useState('')
    const [picLink, setPicLink] = useState('')
    useEffect(() => {
        if (!pictures) {
            history.push(`/coursebase`)
        }
    }, [pictures])

    const handleAddPicture = () => {
        if (picLink) {
            const values = {
                name,
                picLink,
                courseBaseId,
            }
            if (editType === EDIT_TYPE) {
                dispatch(createCourseBasePic(values))
                setName('')
                setPicLink('')
            } else {
                setPictures(() => [...pictures, values])
                setName('')
                setPicLink('')
            }
        }
    }

    const handlePictureDelete = (deletePic) => {
        if (editType === EDIT_TYPE) {
            dispatch(deleteCourseBasePic(deletePic, courseBaseId))
        } else {
            setPictures(() =>
                pictures.filter((pic) => pic.picLink !== deletePic)
            )
        }
    }

    return (
        <Col>
            <PictureAddBase
                name={name}
                picLink={picLink}
                setName={setName}
                setPicLink={setPicLink}
                handleAddPicture={handleAddPicture}
                pictures={pictures}
                editType={editType}
                handlePictureDelete={handlePictureDelete}
            />
        </Col>
    )
}

export default FormCouseBasePictures
